import { useEffect } from "react";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";

// -------------------------------------------------------------------------
// NOTE: FC = Fundraising Center
// This is scoped to hasParentRegistration state through conditional display
// on RegistrationPage.js
// -------------------------------------------------------------------------

const UpdateFCRegistration = ({
    // props
    autoSelectClassification = false,
    categories = [],
    currentPage,
    parentRegistration = {},
    teams = [],
    // actions
    setAppShowRemainingForm,
    updateRegistrationClassification,
}) => {
    const dispatch = useDispatch();
    const { Classification } = parentRegistration;
    const { values, setFieldValue, setFieldTouched } = useFormikContext();

    const { Category } = values;

    // ENUMS
    const {
        ENUMS: {
            DefaultView: { REGISTRATION_DETAILS_STEP },
            EntityType: { REGISTRATION, TEAM },
        },
    } = constants;

    // Classification setting UseEffect
    useEffect(() => {
        if (autoSelectClassification) {
            if (currentPage !== REGISTRATION_DETAILS_STEP) {
                setFieldTouched("Classification");
                setFieldValue("Classification", [`${Classification}`]);
            }

            dispatch(
                updateRegistrationClassification({
                    Classification: [Classification],
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Registration_Role setting UseEffect
    useEffect(() => {
        if (Category?.length > 0) {
            const selectedCategory =
                categories.find(
                    (category) => category.id === Number(Category[0]),
                ) || {};

            if (Object.keys(selectedCategory).length > 0) {
                const { Team: parentTeam, Registration_Role: parentRole } =
                    parentRegistration;

                const { attachIndividual, attachTeamMembers } =
                    selectedCategory;

                switch (Number(parentRole)) {
                    // parent registration was an individual registration
                    case REGISTRATION:
                        if (attachIndividual) {
                            // auto-select ind reg
                            setFieldTouched("Registration_Role");
                            setFieldValue("Registration_Role", [
                                `${REGISTRATION}`,
                            ]);
                            dispatch(setAppShowRemainingForm(true));
                        }
                        break;
                    // parent registration was a team registration
                    case TEAM:
                        if (attachTeamMembers) {
                            const parentTeamData =
                                teams.find(
                                    (team) => team.id === Number(parentTeam),
                                ) || {};
                            // when there is not a classification limit placed on # of team member registrations
                            // remainingSpots is undefined, so we need to set a default of at least 1 for auto-selecting
                            const { remainingSpots = 1 } = parentTeamData;

                            if (remainingSpots > 0) {
                                // auto select team reg
                                setFieldTouched("Registration_Role");
                                setFieldValue("Registration_Role", [`${TEAM}`]);

                                // auto select team
                                setFieldTouched("Team");
                                setFieldValue("Team", parentTeam);
                                dispatch(setAppShowRemainingForm(true));
                            }
                        }
                        break;
                    default:
                        break;
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Category]);

    return null;
};

UpdateFCRegistration.propTypes = {
    // props
    autoSelectClassification: PropTypes.bool.isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentPage: PropTypes.number.isRequired,
    parentRegistration: PropTypes.shape({}),
    teams: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    // actions
    setAppShowRemainingForm: PropTypes.func.isRequired,
    updateRegistrationClassification: PropTypes.func.isRequired,
};

export default UpdateFCRegistration;
